import type { FaireProductEntity } from "../../entity_types/product";

export const p_vgqvvxa8dq: FaireProductEntity = {
  token: "p_vgqvvxa8dq",
  type: "product",
  name: "Little Card Big Thanks Boxed Card Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/2cc3fe3fa479ac91d65c3ccca0da55a387add18797c585ac6a3956003a384462.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f82d6c7ee379fbe19b709bb60cfabc9afa4f3dd3628919e48c4991055158440f.jpeg",
    "https://cdn.faire.com/fastly/d95865cb4fc2017deb5cee818a255b93da3e0499b8d903479a924db19f508752.jpeg",
  ],
  priceDollars: 11,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:46.640Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
